import { Link } from 'react-router-dom'
import { Chevrons } from '@/components/ui'
import { C } from '@/constants/theme'
import { NAV_LINKS, WA_URL } from '@/constants/data'

export function Footer() {
  return (
    <footer style={{ background: C.text, padding: '48px 24px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: 40, marginBottom: 40 }}>
          <div>
            <div style={{ fontFamily: "'Rajdhani', sans-serif", lineHeight: 1, marginBottom: 14 }}>
              <span style={{ fontSize: 22, fontWeight: 700, color: C.white }}>GLASS</span>
              <span style={{ fontSize: 22, fontWeight: 700, color: C.blue }}>TECH</span>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.35)', letterSpacing: 3, marginTop: 1 }}>PTY LTD</div>
            </div>
            <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: 13, lineHeight: 1.7, margin: 0 }}>
              SABS-approved auto glass specialists serving Gauteng. Mobile service — we come to you.
            </p>
          </div>

          <div>
            <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 10, letterSpacing: 3, color: C.blue, textTransform: 'uppercase', marginBottom: 16 }}>Navigation</div>
            {NAV_LINKS.map(l => ({ label: l, path: l === 'Home' ? '/' : `/${l.toLowerCase()}` })).map(({ label, path }) => (
              <Link key={path} to={path} style={{ display: 'block', color: 'rgba(255,255,255,0.45)', fontSize: 14, marginBottom: 8, textDecoration: 'none' }}>{label}</Link>
            ))}
            <a href={WA_URL} target="_blank" rel="noopener noreferrer" style={{ display: 'block', color: 'rgba(255,255,255,0.45)', fontSize: 14, marginBottom: 8, textDecoration: 'none' }}>Get a Quote</a>
          </div>

          <div>
            <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 10, letterSpacing: 3, color: C.blue, textTransform: 'uppercase', marginBottom: 16 }}>Contact</div>
            <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: 13, lineHeight: 2.1 }}>
              <div><a href="tel:+27692145065" style={{ color: 'inherit', textDecoration: 'none' }}>📞 +27 69 214 5065</a></div>
              <div><a href="mailto:sales@glasstech.co.za" style={{ color: 'inherit', textDecoration: 'none' }}>✉️ sales@glasstech.co.za</a></div>
              <div>📍 85 Flamingo Road, Midrand</div>
            </div>
          </div>

          <div>
            <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 10, letterSpacing: 3, color: C.blue, textTransform: 'uppercase', marginBottom: 16 }}>Hours</div>
            <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: 13, lineHeight: 2.1 }}>
              <div>Mon–Fri: 7:30am – 5:00pm</div>
              <div>Saturday: 8:00am – 1:00pm</div>
              <div>Sunday: Closed</div>
            </div>
          </div>
        </div>

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <Chevrons opacity={0.25} />
          <div style={{ color: 'rgba(255,255,255,0.25)', fontSize: 12 }}>
            © {new Date().getFullYear()} GlassTech Pty Ltd. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  )
}
